// router.tsx
import { createHashRouter, RouteObject } from 'react-router-dom';
import LoginPage from "./pages/LoginPage";
import DocumentDetailPage from "./pages/DocumentDetailPage";
import DocumentsListPage from "./pages/DocumentsListPage";
import NewDocument from "./pages/NewDocument";
import DocumentAnalysisPage from "./pages/DocumentAnalysisPage";
import DocumentsComparisonPage from "./pages/DocumentsComparsionPage";
import SettingsPage from "./pages/SettingsPage";
import RootLayout from "./rootLayout";
import AppInitializer from "./components/appInitialization/AppInitializer";

const routes: RouteObject[] = [
    {
        path: '/',
        element: <RootLayout />,
        children: [
            {
                // Публичный маршрут
                path: '/login',
                element: <LoginPage />,
            },
            {
                // Защищённая область: все маршруты ниже доступны только при наличии токена
                element: <AppInitializer  />,
                children: [
                    {
                        path: '/documents',
                        element: <DocumentsListPage />,
                    },
                    {
                        path: '/documents/:documentId',
                        element: <DocumentDetailPage />,
                    },
                    {
                        path: '/documents/new',
                        element: <NewDocument />,
                    },
                    {
                        path: '/analytics/:documentId?',
                        element: <DocumentAnalysisPage />,
                    },
                    {
                        path: '/comparison/:documentId',
                        element: <DocumentsComparisonPage />,
                    },
                    {
                        path: '/settings',
                        element: <SettingsPage />,
                    },
                ],
            },
        ],
    },
];

const router = createHashRouter(routes);

export default router;
